import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 16V24C5 24.5523 5.44772 25 6 25H26C26.5523 25 27 24.5523 27 24V16" stroke="#0090FF" strokeWidth="2" />
      <path
        opacity="0.5"
        d="M19 25L19 19C19 18.4477 18.5523 18 18 18L14 18C13.4477 18 13 18.4477 13 19L13 25"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <path opacity="0.5" d="M2 29H30" stroke="#0090FF" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M4.64729 3.79604C4.7439 3.33233 5.1526 3 5.62628 3H26.3737C26.8474 3 27.2561 3.33233 27.3527 3.79605L29.0194 11.796C29.1487 12.417 28.6747 13 28.0404 13H3.95961C3.32529 13 2.85126 12.417 2.98063 11.796L4.64729 3.79604Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5H7V11H9V5ZM11 5H13V11H11V5ZM15 5H17V11H15V5ZM19 5H21V11H19V5ZM25 5H23V11H25V5Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export default Svg;
